type MuxSourceInfo = { type: 'mux'; src: string; preload: 'none'; muxPlaybackId: string; poster: string };
type GenericSourceInfo = { type: 'other'; src: string; preload: 'auto' };
export type VideoSourceInfo = MuxSourceInfo | GenericSourceInfo;

/**
 * Regular expression that matches a Mux Stream video URL and captures the playback ID.
 */
const MUX_VIDEO_RE = /^https?:\/\/stream\.mux\.com\/([a-zA-Z0-9]+)/;

/**
 * See: https://www.w3.org/TR/media-frags/#URIfragment-user-agent
 */
const URI_FRAGMENT = '#t=0.0001';

/**
 * Parses additional video source info from a video URL.
 *
 * For Mux URLs, we extract the playback ID so the MuxPlayer component can be used directly, and
 * build a poster image URL from the Mux image API so we can avoid preloading the video.
 *
 * For any other URL, this returns the `src` property that should be used on the video element. The
 * video can be preloaded by the browser to display a frame as a poster. We add a tiny fragment to
 * the URL to offset the first frame which is sometimes blank.
 */
export function parseSourceInfoFromUrl(videoUrl: string): VideoSourceInfo {
	const muxMatch = MUX_VIDEO_RE.exec(videoUrl);

	const playbackId = muxMatch?.[1];

	if (playbackId) {
		return {
			type: 'mux',
			src: videoUrl,
			preload: 'none',
			muxPlaybackId: playbackId,
			poster: `https://image.mux.com/${playbackId}/thumbnail.jpg?time=0.1`,
		};
	}

	return {
		type: 'other',
		src: videoUrl + URI_FRAGMENT,
		preload: 'auto',
	};
}
